import React from 'react';
import { STRUCTURED_DATA, SEO_CONTENT } from '../constants/seoData';

const StructuredData = () => {
  const faqData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": SEO_CONTENT.faq.map(item => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer
      }
    }))
  };

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(STRUCTURED_DATA.software)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(faqData)}
      </script>
    </>
  );
};

export default StructuredData;
